import html2pdf from "html2pdf.js"
import logoUrl from "../assets/Logo.png"
import { maskFunctions } from "./maskServices"
import { queriesAttributes } from "../interfaces"

const TABLOID_WIDTH_MM = 279.4
const TABLOID_HEIGHT_MM = 431.8

const sanitizeFilename = (value: string) => value.replace(/[\\/:*?"<>|]/g, "-").replace(/\s+/g, " ").trim()

const getCustomerName = (query: queriesAttributes) => {
    const name = query.type === "PF"
        ? query.result_biro?.BestInfo?.PersonName?.Name?.Full
        : query.result_biro?.BestInfo?.CompanyName
    return sanitizeFilename(name || "PESSOA NÃO ENCONTRADA PELO BIRÔ DE CRÉDITO")
}

const getAuthorName = (query: queriesAttributes) => query.person?.registration_data?.name || "Imobiliária"

const formatDate = (value: string) => new Intl.DateTimeFormat("pt-BR", {
    dateStyle: "short",
    timeStyle: "short"
}).format(new Date(value))

const imageAsDataUrl = (url: string) => new Promise<string>((resolve, reject) => {
    const image = new Image()
    image.onload = () => {
        const canvas = document.createElement("canvas")
        canvas.width = image.naturalWidth
        canvas.height = image.naturalHeight
        canvas.getContext("2d")?.drawImage(image, 0, 0)
        resolve(canvas.toDataURL("image/png"))
    }
    image.onerror = reject
    image.src = url
})

export const getQueryPdfUrl = ({ queryId, franchiseId, token }: {
    queryId: string
    franchiseId?: string
    token?: string
}) => {
    const params = new URLSearchParams({ franchise_id: franchiseId || "", token: token || "", download: "true" })
    return `/query-pdf/${queryId}?${params.toString()}`
}

export const downloadQueryPdf = async (element: HTMLElement, query: queriesAttributes) => {
    await document.fonts?.ready
    await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)))

    let logo: string | null = null
    try {
        logo = await imageAsDataUrl(logoUrl)
    } catch (_) {
        // The report remains valid if the optional brand image cannot be loaded.
    }

    const worker = html2pdf().set({
        filename: `${getCustomerName(query)}.pdf`,
        margin: [24, 10, 24, 10],
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true, logging: false, windowWidth: element.scrollWidth },
        jsPDF: { unit: "mm", format: [TABLOID_WIDTH_MM, TABLOID_HEIGHT_MM], orientation: "portrait" },
        pagebreak: { mode: ["css", "legacy"], avoid: [".avoid-page-break"] }
    }).from(element).toPdf()

    await worker.get("pdf").then((pdf: any) => {
        const pages = pdf.internal.getNumberOfPages()
        const customerName = getCustomerName(query)
        const documentLabel = query.type === "PF" ? "CPF" : "CNPJ"
        const documentValue = maskFunctions.cpfOrCnpj.mask(query.cpf_cnpj)

        for (let page = 1; page <= pages; page++) {
            pdf.setPage(page)
            pdf.setFontSize(8)
            pdf.setTextColor(55, 55, 55)
            pdf.text(`ANÁLISE DE ${customerName}`, 12, 10)
            pdf.text(`${documentLabel}: ${documentValue}`, 12, 15)
            if (logo) pdf.addImage(logo, "PNG", TABLOID_WIDTH_MM - 38, 7, 26, 8)
            pdf.text(`AUTOR: ${getAuthorName(query)}`, 12, TABLOID_HEIGHT_MM - 16)
            pdf.text(`DATA DE EMISSÃO: ${formatDate(query.createdAt)}`, 12, TABLOID_HEIGHT_MM - 11)
            pdf.text(`CÓDIGO: ${query.id}`, 12, TABLOID_HEIGHT_MM - 6)
            pdf.text(`PÁGINA ${page} DE ${pages}`, TABLOID_WIDTH_MM - 12, TABLOID_HEIGHT_MM - 6, { align: "right" })
        }
    })

    await worker.save()
}
